var React = require('react');

function SearchIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"50","strokeWidth":"2","d":"M13.005 13.005L9.35 9.35"})),React.createElement("g",{"key":1},React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"50","strokeWidth":"2","d":"M5.889 10.778a4.889 4.889 0 1 0 0-9.778 4.889 4.889 0 0 0 0 9.778z"}))])));
}

SearchIconInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = SearchIconInline;

SearchIconInline.default = SearchIconInline;
